module.exports = __webpack_public_path__ + "img/home-banner-contact2-en.62f03a3e.png";